import { ref } from 'vue'

// Singleton state so root container and layout files share the same drawer visibility
const isOpen = ref(false)

/**
 * Global state for the mobile sidebar drawer.
 * Used by GKRootContainer (hamburger click) to open, and by layout files
 * (communities-groups, communities-users, PostsPageLayout.mobile, etc.)
 * to render the drawer and bind v-model:show.
 */
export const useSidebarDrawer = () => {
  const open = () => {
    isOpen.value = true
  }
  const close = () => {
    isOpen.value = false
  }
  const toggle = () => {
    isOpen.value = !isOpen.value
  }
  return {
    isOpen,
    open,
    close,
    toggle,
  }
}
